import { createContext, useContext } from "react";

export const CustomerWebsiteTabsContext = createContext(null);

export const useCustomerWebsiteTabs = () =>
  useContext(CustomerWebsiteTabsContext);
